<script>
    import Button, { Group, GroupItem, Label, Icon } from "@smui/button";
    import Textfield, { Input, Textarea } from "@smui/textfield";
    import { onMount } from "svelte";
    import { writable } from "svelte/store";
    import { createEventDispatcher } from "svelte"
    import API from "../../API/API";
    import Vessel from "../../Models/Vessel";
    import LoadState from "../../Enums/LoadState";
    import FormContainer from "../../UI/Admin/Form.svelte";
    
    export let vessel = writable(new Vessel()); // null;
    export let threadId = "";

    const dispatch = createEventDispatcher(); // update

    let form = null;
    let newThreadTitle = writable("");
    let newThreadBody = writable("");
    let replyingTo = writable(threadId === ""?null:threadId);
    let loadState = writable(LoadState.INIT);

    $: if (form) form.setReadOnly($loadState != LoadState.INIT);
    
    let submitNewComment = () => {
        let data = {
            message: $newThreadBody
        };
        let pathThread;
        if ($replyingTo !== null) {
            pathThread = $replyingTo
        }
        else {
            data.title = $newThreadTitle
            data.spire_id = $vessel.spireId;
            data.for = "vessel";
            data.imo = $vessel.imo;
            data.mmsi = $vessel.mmsi;
            data.name = $vessel.name;
            pathThread = "create";
        }
        $loadState = LoadState.LOADING;
        API.put("comments/" + pathThread, data)
            .then((response)=>{
                console.log(response);
                $loadState = LoadState.LOADED;
                dispatch("success", {
                    comment: response.comment,
                    thread: response.thread
                });
            })
            .catch((err)=>{
                console.error(err);
                $loadState = LoadState.INIT;
            });
    };
    let cancelNewComment = () => {
        dispatch("cancel");
    };

</script>
<style>
    #vessel-notes-form .msg { 
        background-color: #eee;
    }
    #vessel-notes-form h2.heading {
        margin-top:0px;
        margin-bottom:5px;
    }
    #vessel-notes-form .input-text {
        display:block; 
        width:calc(100% - 12px); 
        padding:5px;
        margin:0px;
        line-height:20px;
        border:1px solid grey;
        margin-bottom:5px;
        border-radius:3px;
    }
</style> 

<FormContainer bind:this={form}>
    <div id='vessel-notes-form'>
        <div class="msgbox mb-10 oa form msg">
            <h2 class='heading'>New {#if $replyingTo === null}Thread{:else}Reply{/if}</h2>
            {#if $replyingTo === null}
                <input type="text" class="input-text" placeholder="Thread Title (optional)" bind:value={$newThreadTitle} />
            {/if}
            <textarea class="input-text" style="min-height:60px;" placeholder="Insert note/comment..." bind:value={$newThreadBody}></textarea>
            <Button on:click={submitNewComment} fullwidth color="secondary" variant="unelevated" style='margin-top:0px;width:100%;margin-bottom:5px;'>
                <Label>Submit</Label>
            </Button>
            <Button on:click={cancelNewComment} title="Reset" class='bg-info' variant="unelevated" style="width:100%;margin-top:0px;">
                <Label>Cancel</Label>
            </Button>
        </div>
    </div>
</FormContainer>